import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'
import {jumpToUser} from 'src/helper/webviewFun'
import lang from '../lang'
import { isRtl } from 'src/helper/tool'

export default class extends React.Component {
  state = {
  }

  constructor(props) {
    super(props)
  }

  componentDidMount() {
  }

  componentWillReceiveProps(e) {
  }

  render() {
    let { language, lang, lastWeekRecord } = this.props
    let { rewardMembers } = lastWeekRecord

    let status = ''
    switch (lastWeekRecord.status) {
      case 1:
        status = lang.status1
        break
      case 2:
        status = lang.status2
        break
      case 3:
        status = lang.status3
        break
      case 4:
        status = lang.status4
        break
    }

    // if (!rewardMembers || rewardMembers.length == 0) {
    //   return (<div></div>)
    // }

    return (
      <div className="lastWeekAward">
        <div className="title">
          {lang.lastWeekAward}
        </div>
        <div className="content">
          <div className="items">
            <div className={`item item1 ${isRtl(language) && 'arlang'}`}>
              <div className="gold">
                {lang.roomGold}
              </div>
              <div className="score">
                {lastWeekRecord.groupGold}
              </div>
            </div>
            <div className="line">
            </div>
            <div className="item item2">
              <div className="gold">
                {lang.awardLv}
              </div>
              <div className="score">
              {(lastWeekRecord.rewardLv && lastWeekRecord.rewardLv )}
                {/* {(lastWeekRecord.rewardLv && lastWeekRecord.rewardLv > 0) ? `LV.${lastWeekRecord.rewardLv}` : lang.status1} */}
              </div>
            </div>
            <div className="line">
            </div>
            <div className={`item item3 ${language == 'ar' && 'arlang'}`}>
              <div className="gold">
                {lang.awardStatus}
              </div>
              <div className="score">
                {status}
              </div>
            </div>
          </div>

          {(rewardMembers && rewardMembers.length > 0) && <div className="awardListTitle">{lang.rewardList}</div>}

          {(rewardMembers && rewardMembers.length > 0) && <div className="awardUsersList">
            {rewardMembers.map((item, index) => {
              return (<div className="item" onClick={jumpToUser.bind(this, item.uid)}>
                <img src={`${cdn(item.avatarurl)}`} className="logo" />
              </div>)
            })}
          </div>}

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport-op/LastWeekAward/index.js